import React from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Text,
} from "@chakra-ui/react";
import "./breadscrum.css";
// Actions
import * as mainActions from "../../../redux/actions/main";
// Utils
import { getText } from '../../../utils/lang';

const MainBreadscrum = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Selectors
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => state.mainReducer.breadscrum);

  // Set vars
  const breadscrumPieces = !!breadscrum[currentPage] ? breadscrum[currentPage] : [];

  const renderPath = (i) => {
    const isNavigable = breadscrumPieces.length > 0 && i < (breadscrumPieces.length - 1);
    const isLast = (i === (breadscrumPieces.length - 1));

    // Set sx
    let sx = {};
    if (isNavigable) {
      sx = {
        _hover: {
          color: `hover`,
        }
      };  
    }

    // Set sufix
    let pathKey;
    let sufixText = '';
    if (i === -1) {
      pathKey = currentPage;
    } else {
      const breadscrumPiece = breadscrumPieces[i];
      pathKey = breadscrumPiece.pathKey;
      if (!!breadscrumPiece.itemNameSingular) {
        sufixText += ` ${breadscrumPiece.itemNameSingular}`;  
      }
      if (!!breadscrumPiece.primaryValue) {
        if (isLast) {
          sufixText += ` (`;  
          sufixText += breadscrumPiece.primaryValue;
          if (!!breadscrumPiece.primaryName) {
            sufixText += ` - ${
              breadscrumPiece.primaryName.length > 50 
                ? breadscrumPiece.primaryName.slice(0, 50) + "..." 
                : breadscrumPiece.primaryName
            }`;
          }
          sufixText += `)`;
        } else {
          // if (i === 0) {
            sufixText += ` (${breadscrumPiece.primaryValue})`;  
          // }
        }
      }
    }
    // Set text
    const text = getText(pathKey) + sufixText;

    // set text bold
    const isBold = (i === (breadscrumPieces.length - 1));

    return ( 
      <Box 
        cursor={isNavigable ? "pointer": "default"}
        onClick={() => {
          if (!isNavigable) return;
          let newBreadscrum;
          let goTo;
          if (i === -1) {
            // Reset breadscrum to go start
            newBreadscrum = [];
            goTo = currentPage;
          } else {
            newBreadscrum = breadscrumPieces.slice(0, i + 1);
            const lastPiece = newBreadscrum[newBreadscrum.length - 1];    
            goTo = lastPiece.path;
          }
          // Set bread scrum
          dispatch(mainActions.setBreadscrum(currentPage, newBreadscrum));  
          // Goto
          navigate(`/${goTo}`);  
        }}
      >
        <Text 
          color="dark" 
          fontSize="sm"
          fontWeight={isBold? "bold": "normal"}
          sx={sx}     
        >
          {text}
        </Text>          
      </Box>
    );
  };

  let indent = [];

  for (var i = -1; i < breadscrumPieces.length; i++) { 
    indent.push(
      renderPath(i)
    );
    const isLast = (i === (breadscrumPieces.length - 1));
    if (!isLast || i === -1) {
      indent.push(
        <Text color="dark" fontSize="sm" >
          &nbsp;{" > "}&nbsp;
        </Text>              
      )
    }
  }

  return (
    <div id="main-breadscrum">
      {indent}
    </div>
  );
};

export default MainBreadscrum;
